import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateBillingNote } from '../api/UpdateBillingNote';
import type { BillingNoteInput } from '../types/BillingNoteInput';

interface UpdateBillingNoteParams {
  billingUuid: string;
  noteUuid: string;
  note: BillingNoteInput;
}

export const useUpdateBillingNote = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ billingUuid, noteUuid, note }: UpdateBillingNoteParams) =>
      updateBillingNote(billingUuid, noteUuid, note),
    onSuccess: async (_, { billingUuid }) => {
      await queryClient.invalidateQueries({
        queryKey: ['billing-notes', billingUuid],
      });
      await queryClient.invalidateQueries({ queryKey: ['billings'] });
    },
  });

  return { updateNote: mutate, isPending };
};
